import React, { Component } from 'react'
import './radiobutton.scss'

class Radiobutton extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isChecked: Boolean(props.isChecked) || '',
			type: props.type ? props.type : 'radio',
			id: props.id ? props.id : '',
			name: props.name ? props.name : '',
			imgSrc: props.imgSrc ? props.imgSrc : '',
			for: props.for ? props.for : '',
			label: props.label ? props.label : '',
			state: props.state ? props.state : '',
			value: props.value ? props.value : '',
			labelClasses: props.labelClasses ? props.labelClasses : '',
			classes: props.classes ? props.classes : '',
			onChange: props.onChange ? props.onChange : '',
			icon: props.icon ? props.icon : ''
		}
	}

	render() {
		const classes = ['input', this.state.classes, this.state.state].join(' ')
		let labelClass = ['group vbui--radio', this.props.labelClasses].join(' ')
		if (this.state.icon) {
			labelClass = ['icon', labelClass].join(' ')
		}
		return (
			<div className={labelClass}>
				<input
					defaultChecked={this.props.isChecked}
					id={this.state.id}
					name={this.state.name}
					disabled={this.props.disabled}
					className={classes}
					type={this.state.type}
					data-key={this.props['data-key']}
					data-value={this.props['data-value']}
					onClick={this.props.onClick}
					onChange={this.props.onChange}
				/>
				<label htmlFor={this.state.id}>
					{this.state.imgSrc && <img alt="" src={this.state.imgSrc} />}
					{this.state.icon && <span className={this.state.icon}></span>}
					{this.state.label}
					{this.props.children}
				</label>
			</div>
		)
	}
}

export default Radiobutton
